<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="card-title">{{$t('medium_grant.diligence__1_capacity_questionaire')}}</h3>
        <p>{{$t('medium_grant.diligence__2_capacity_questionaire_sub2')}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4"></div>
        <p>{{$t('medium_grant.diligence__10_top_info')}}</p>
        <div class="mt-4 mb-3">
          <a class="link-download" :href="downloadFiles[$i18n.locale]" target="_blank">{{$t('medium_grant.diligence__10_download_template')}}</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-7">
        <table class="mt-3" width="100%">
          <thead>
          <th>{{$t('medium_grant.diligence__10_co_applicants')}}</th>
          <th>{{$t('medium_grant.diligence__10_upload')}}</th>
          </thead>
          <tbody>
          <tr v-for="(coapplicant, index) in coApplicants" :key="index">
            <td>
              <div class="form-group">
          <textarea
            class="form-control"
            v-model="coapplicant.name"
            :placeholder="$t('medium_grant.diligence__10_name_of_coapplicant')"
          >
          </textarea>
              </div>
            </td>
            <td class="vertical-align-baseline">
              <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.diligence['coApplicants' + (index+1)]" :file-data="GrantForm.files.diligence['coApplicants' + (index+1)]" :is-editable="GrantForm.isEditable" :section="'diligence.coApplicants' + (index + 1)"></upload-file>
            </td>
          </tr>
          </tbody>
          <base-button v-if="coApplicants.length < maxCoApplicants" @click="addCoApplicantRow" type="primary" class="btn-simple" size="sm">
            + {{$t('general.add_row')}}
          </base-button>
        </table>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        coApplicants: [],
        maxCoApplicants: 10,
        downloadFiles: {
          en: '/files/en/BIOPAMA_AC_MediumGrants_Due_diligence_questionnaire_for_co-applicants_EN_2019.docx',
          fr: '/files/fr/BIOPAMA_FA_Subventions Moyennes-Questionnaire-co-demandeur_FR_2019.docx'
        }
      }
    },
    methods: {
      addCoApplicantRow() {
        if (this.coApplicants.length >= this.maxCoApplicants) return;
        this.coApplicants.push({
          name: '',
          upload: ''
        });
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    },
    mounted() {
      this.addCoApplicantRow();

      if (GrantForm.model.diligence.coApplicants) {
        this.coApplicants = GrantForm.model.diligence.coApplicants;
      }
    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }
</style>